// pages/Contact/styles.js
import styled from 'styled-components';
import { Button } from '../../styles/components';

export const ContactWrapper = styled.div`
    min-height: calc(100vh - 72px);
    margin-top: 72px;
    background: ${props => props.theme.colors.background.alt};
`;

export const ContactHeader = styled.div`
    background: ${props => props.theme.colors.background.paper};
    padding: ${props => props.theme.spacing['4xl']} 0;
    text-align: center;
    border-bottom: 1px solid ${props => props.theme.colors.border};
    margin-bottom: ${props => props.theme.spacing['4xl']};

    h1 {
        font-size: ${props => props.theme.typography.sizes['4xl']};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.md};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        font-size: ${props => props.theme.typography.sizes.lg};
    }
`;

export const ContactContent = styled.div`
    max-width: 600px;
    margin: 0 auto;
    padding: ${props => props.theme.spacing.xl};
`;

export const InfoCard = styled.div`
    display: flex;
    align-items: flex-start;
    gap: ${props => props.theme.spacing.lg};
    background: ${props => props.theme.colors.background.paper};
    padding: ${props => props.theme.spacing.xl};
    border-radius: ${props => props.theme.borderRadius.lg};
    margin-bottom: ${props => props.theme.spacing.lg};
    box-shadow: ${props => props.theme.shadows.sm};

    svg {
        color: ${props => props.theme.colors.primary.main};
        flex-shrink: 0;
    }

    .info {
        flex: 1;

        h3 {
            font-size: ${props => props.theme.typography.sizes.lg};
            margin-bottom: ${props => props.theme.spacing.xs};
            color: ${props => props.theme.colors.text.primary};
        }

        p {
            color: ${props => props.theme.colors.text.secondary};
            line-height: 1.6;
            margin-bottom: ${props => props.theme.spacing.md};
        }
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: ${props => props.theme.spacing.md};
    margin-top: ${props => props.theme.spacing.md};

    @media (max-width: ${props => props.theme.breakpoints.sm}) {
        flex-direction: column;
    }
`;

export const ActionButton = styled(Button)`
    display: inline-flex;
    align-items: center;
    gap: ${props => props.theme.spacing.sm};
    text-decoration: none;
    
    svg {
        color: inherit;
    }
`;

export const SocialLinks = styled.div`
    text-align: center;
    background: ${props => props.theme.colors.background.paper};
    padding: ${props => props.theme.spacing.xl};
    border-radius: ${props => props.theme.borderRadius.lg};
    box-shadow: ${props => props.theme.shadows.sm};

    h3 {
        font-size: ${props => props.theme.typography.sizes.lg};
        margin-bottom: ${props => props.theme.spacing.lg};
        color: ${props => props.theme.colors.text.primary};
    }

    .social-buttons {
        display: flex;
        justify-content: center;
        gap: ${props => props.theme.spacing.md};
    }
`;